import ContentList from "../../../customUiForCs/ContentList";
import ZoneCard from "../zones/ZoneCard";

export default function NomenclatureOfZone({
  columns = 1,
  disableFilters,
  inheritedSearchQuery,
  buttons,
}) {
  return (
    <ContentList
      disableFilters={disableFilters}
      inheritedSearchQuery={inheritedSearchQuery}
      //
      columns={columns}
      permissionName={"zonePermissions"}
      title="Zones"
      path="zones"
      CardComponent={ZoneCard}
      buttons={buttons}
    />
  );
}
